import ScrollFunc from './scrollfunc';
import Slider from './slider';
import CommonFunction from './common_functions';
export default class UI {
    constructor() {
        this.screenHeight = 0;
        this.scrollfunc = new ScrollFunc();
        this.slider = new Slider();
        this.CommonFunction = new CommonFunction(this.scrollfunc);

        this.init();
    }

    init() {
        //methods
        this.update();
        this.eventBind();
    }

    update() {
        this.screenHeight = window.innerHeight;
        document.documentElement.style.setProperty('--screenHeight', `${this.screenHeight}px`);
    }

    eventBind() {
        window.onload = function () {
            const elm = document.getElementsByTagName('body');
            elm[0].classList.add('-ready');
        }
        window.addEventListener('resize', this.update);
    }
}
